import { createRouter, createWebHistory } from 'vue-router';
import { authGuard } from '@/auth';

const routes = [
  // Veřejné
  { path: '/', name: 'home', component: () => import('@/views/HomePage.vue'), meta: { title: 'Hlášení závad v Praze 2' } },
  { path: '/nahlasit', name: 'report', component: () => import('@/views/PothoReport.vue'), meta: { title: 'Nahlásit závadu' } },
  { path: '/mapa', name: 'map', component: () => import('@/views/MapPage.vue'), meta: { title: 'Mapa hlášení' } },
  { path: '/tracking/:id', name: 'tracking', component: () => import('@/views/TrackingPage.vue'), meta: { title: 'Stav hlášení' } },
  { path: '/resolve/:token', name: 'resolve', component: () => import('@/views/ResolvePage.vue'), meta: { title: 'Potvrzení opravy' } },

  // Admin
  { path: '/admin/login', name: 'admin-login', component: () => import('@/views/SignIn.vue'), meta: { title: 'Přihlášení do administrace' } },
  { path: '/admin', name: 'admin', component: () => import('@/views/AdminDashboard.vue'), meta: { requiresAuth: true, title: 'Administrace' } },
  { path: '/admin/users', name: 'users', component: () => import('@/views/UserManagement.vue'), meta: { requiresAuth: true, title: 'Uživatelé' } },
  { path: '/admin/users/new', name: 'users-new', component: () => import('@/views/CreateUser.vue'), meta: { requiresAuth: true, title: 'Nový uživatel' } },
  { path: '/admin/sluzby', name: 'services', component: () => import('@/views/MunicipalServiceManagement.vue'), meta: { requiresAuth: true, title: 'Městské služby' } },
  { path: '/admin/statistiky', name: 'stats', component: () => import('@/views/StatisticsPage.vue'), meta: { requiresAuth: true, title: 'Statistiky' } },
  { path: '/admin/nastaveni', name: 'settings', component: () => import('@/views/Settings.vue'), meta: { requiresAuth: true, title: 'Nastavení' } },

  // Service portal
  { path: '/sluzba/:slug', name: 'service-portal', component: () => import('@/views/ServicePortal.vue'), meta: { title: 'Portál městské služby' } },

  { path: '/:pathMatch(.*)*', name: 'not-found', component: () => import('@/views/NotFound.vue'), meta: { title: 'Stránka nenalezena' } }
];

const router = createRouter({ history: createWebHistory(), routes });

/** Název aplikace v titulku okna — za pomlčkou na každé stránce. */
export const APP_NAME = 'RoadPatrol';

/**
 * Titulek okna podle routy. Bez toho nesly všechny záložky i položky historie
 * stejný text a nešly od sebe rozeznat.
 */
export function titulekRouty(route) {
  const t = route?.meta?.title;
  return t ? `${t} — ${APP_NAME}` : `${APP_NAME} — Hlášení závad MČ Praha 2`;
}

// Přihlášení řeší auth.js: chráněná stránka bez PLATNÉHO tokenu → přihlášení
// s návratem (?redirect=), přihlášený uživatel na /admin/login → rovnou dovnitř.
router.beforeEach((to, from, next) => {
  const cil = authGuard(to);
  return cil === true ? next() : next(cil);
});

router.afterEach((to) => {
  document.title = titulekRouty(to);
});

export default router;
